import { render } from "./MostPopularComponent.vue?vue&type=template&id=051023e5"
import script from "./MostPopularComponent.vue?vue&type=script&lang=js"
export * from "./MostPopularComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/home/MostPopularComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "051023e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('051023e5', __exports__)) {
    api.reload('051023e5', __exports__)
  }
  
  module.hot.accept("./MostPopularComponent.vue?vue&type=template&id=051023e5", () => {
    api.rerender('051023e5', render)
  })

}


export default __exports__